import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import React from 'react';
import { AnnouncementBanner } from '../Feature/Home/AnnouncementBanner';
import BackgroundVideoSection from '../Feature/Home/BackgroundVideoSection';
import CommunityFunSection from '../Feature/Home/CommunityFunctions';
import { HeroSection } from '../Feature/Home/HeroSection';
import JoinCommunity from '../Feature/Home/JoinCommunity';
import LocationAndHours from '../Feature/Home/LocationAndHours';
import ProgramsSection from '../Feature/Home/ProgramsSection';
import { COLORS } from '../Constants/styles';
// import ProgramsSection from '../Feature/ProgramsCard';

// Define functional component for Home page

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const Home: React.FC = () => {
  return (
    <div style={{ color:COLORS.pureBlack,  }}>
      <HeroSection />
      <AnnouncementBanner />
      <ProgramsSection />
      <BackgroundVideoSection />
      <CommunityFunSection />
      <LocationAndHours />
      <JoinCommunity />
      {/* <FooterSection />  */}
    </div>
  );
};

export default Home;
